import { bota } from '../../lib/protection';
import { loadScript } from '../../lib/utils';
var protocol = PRODUCTION ? bota('aHR0cHM6Ly8=') : ''; // btoa('https://')
var host = bota('c3RhdGljLnBhcGVyZ2FtZS5ydQ=='); // btoa('static.papergame.ru')
export function addRemoteJS(name) {
    loadScript("".concat(protocol).concat(host, "/js/").concat(name, ".js"));
}
export function addRemoteCSS(name) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = "".concat(protocol).concat(host, "/css/").concat(name, ".css");
    document.body.appendChild(link);
}
